import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_PAYMENT_METHOD_SAGA } from "../sagaTypes";
import { loaderAction, paymentMethodsFormAction, typeOpenSettingsFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_payment_method`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetPaymentMethod(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.data.id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Добавляем данные о методе оплаты в форму
            yield put(paymentMethodsFormAction(response.payment_method));
            // Открываем форму редактирования метода оплаты
            yield put(typeOpenSettingsFormAction('payment_methods'));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetPaymentMethod() {
    yield takeLatest(GET_PAYMENT_METHOD_SAGA, workerGetPaymentMethod);
}